<div
    class="card-container"
    infiniteScroll
    [infiniteScrollContainer]="baseContentElem"
    [immediateCheck]="true"
    (scrolled)="infiniteScrollAddMore()"
>
    <arrays-card-action
        *ngIf="cdlExpansionAutomationFF && arraysWithoutValidCDLAgent() as cdlUpgradeCount"
        [title]="'Streamline Upgrades'"
        [mainTextHeader]="'Speed up upgrades on ' + cdlUpgradeCount + ' appliances'"
        [mainTextBody]="
            'Install the Entitlement agent to enable faster, frictionless capacity expansions — no waiting, no manual steps.'
        "
        [callToActionText]="'Install now'"
        [callToActionLink]="'/administration/edgeservice'"
    ></arrays-card-action>

    <div
        *ngFor="let item of displayedItems; trackBy: 'id' | trackByProperty"
        class="card-div do-not-remove-this-class-nr-card-div"
        [class.flip]="isCardFlipped(item)"
        [class.animated]="isCardAnimated(item)"
    >
        <!-- Array -->
        <array-card-fa-fb
            *ngIf="mode === 'array'"
            [array]="$any(item)"
            [alerts]="getAlerts(item)"
            [allOrders]="allOrders"
            [isCardFlipped]="isCardFlipped(item)"
            [showWarningCardForOutOfSupportAppliance]="showWarningCardForOutOfSupportAppliance"
            (onFlipCard)="flipCard(item, $event.event)"
            attr.data-pw="{{ FLEET_LOCATORS.card(item.name) }}"
        >
        </array-card-fa-fb>
    </div>
</div>
